export default "__VITE_ASSET__Bi$seDkE__"